import React from "react";
import { History } from "history";
import {
  PlanoVinculadoEntidade,
  ContratoEntidade,
  ParametrosSimulacao,
  ContratoDisponivel,
} from "../../../entidades";
import { MasterPage } from "../..";
import { NumFuncionalidade } from "../../MasterPage";
import {
  Box,
  CampoEstatico,
  TipoCampoEstatico,
  Alerta,
  TipoAlerta,
  Botao,
  TipoBotao,
} from "@intechprev/componentes-web";
import { IParametrosSimulacao } from ".";
import { EmprestimoService } from "../../../services";
import { reCAPTCHA } from "../../../helpers";

interface IProps {
  history?: History;
}

interface IState {
  plano: PlanoVinculadoEntidade;
  emprestimos: Array<ContratoEntidade>;
  valorSolicitado: number;
  valorMargemConsignavel: number;
  saldoContratosAtivos: number;
  valorFinanciado: number;
  listaContratos: Array<ContratoDisponivel>;
  contratoSelecionado: ContratoDisponivel;

  erro: string;
}

export class SimuladorEmprestimoPrestacoes extends React.Component<
  IProps,
  IState
> {
  private recaptcha = new reCAPTCHA("emprestimo_simulador_prestacoes");

  private page = React.createRef<MasterPage>();

  constructor(props: IProps) {
    super(props);

    const dados: IParametrosSimulacao = JSON.parse(
      localStorage.getItem("emprestimo-parametros")
    );

    var recursoUtilizado = 0;

    if (dados.emprestimos.length > 0) {
      var indiceUltimaPrestacao =
        dados.emprestimos[0].Prestacoes.length - 1;
      recursoUtilizado =
        dados.emprestimos[0].Prestacoes[indiceUltimaPrestacao]
          .VL_SALDO_ATUAL;
    }

    this.state = {
      plano: dados.plano,
      emprestimos: dados.emprestimos,
      valorSolicitado: dados.valorSolicitado,
      valorMargemConsignavel: dados.valorMargemConsignavel,
      saldoContratosAtivos: recursoUtilizado,
      valorFinanciado: dados.valorSolicitado + recursoUtilizado,
      listaContratos: [],
      contratoSelecionado: null,

      erro: null,
    };
  }

  componentDidMount = async () => {
    try {
      await this.page.current.alternarLoading();

      var parametros: ParametrosSimulacao = {
        CdPlano: this.state.plano.CD_PLANO,
        ValorMargem: this.state.valorMargemConsignavel,
        ValorSolicitado: this.state.valorSolicitado,
      };

      var listaContratos = await EmprestimoService.BuscarParcelas(parametros);
      await this.setState({
        listaContratos,
      });

      await this.page.current.alternarLoading();
    } catch (error) {
      await this.setState({
        erro: error.response ? error.response.data : error,
      });

      await this.page.current.alternarLoading();
    }
  };

  selecionarContrato = async (contrato: ContratoDisponivel) => {
    if (contrato.Disponivel) {
      const listaContratos = this.state.listaContratos.map((item) => {
        return {
          ...item,
          Selecionado: item.Prazo === contrato.Prazo,
        };
      });

      contrato.Selecionado = true;

      await this.setState({
        listaContratos,
        contratoSelecionado: contrato,
      });
    }
  };

  continuar = async () => {
    if (this.state.contratoSelecionado) {
      await localStorage.setItem(
        "emprestimo-contrato-selecionado",
        JSON.stringify(this.state.contratoSelecionado)
      );
      this.props.history.push("/simuladorEmprestimoResumo");
    }
  };

  render() {
    return (
      <MasterPage
        Funcionalidade={NumFuncionalidade.EMPRESTIMOS_SIMULAÇÃO}
        {...this.props}
        ref={this.page}
      >
        <h3>Bem-Vindo ao Simulador de Empréstimos da PREVIRB!</h3>
        <h5>
          Ao final da sua simulação você poderá realizar o
          requerimento do seu empréstimo diretamente por aqui, de
          forma on-line e segura!
        </h5>

        <Box titulo={"Prazos e Prestações"}>
          <p>Selecione o melhor prazo/taxa disponível para você!</p>

          <CampoEstatico
            titulo={"Valor Solicitado"}
            valor={this.state.valorSolicitado}
            tipo={TipoCampoEstatico.dinheiro}
          />

          <CampoEstatico
            titulo={"Saldo Contratos Ativos"}
            valor={this.state.saldoContratosAtivos}
            tipo={TipoCampoEstatico.dinheiro}
          />

          {this.state.erro && (
            <Alerta
              tipo={TipoAlerta.danger}
              mensagem={this.state.erro}
            />
          )}
          {this.state.listaContratos.length > 0 && (
            <table
              className={"table table-hover mt-5"}
              style={{ cursor: "pointer" }}
            >
              <thead>
                <tr>
                  <th></th>
                  <th style={{ width: "70px" }}>Prazo</th>
                  <th style={{ width: "70px" }}>Taxa</th>
                  <th style={{ width: "120px" }}>
                    Prestação
                  </th>
                  <th style={{ width: "120px" }}>
                    Taxas/Encargos
                  </th>
                  <th style={{ width: "120px" }}>
                    Líquido a Receber
                  </th>
                  <th>Disponibilidade</th>
                </tr>
              </thead>
              <tbody>
                {this.state.listaContratos.map(
                  (contrato: ContratoDisponivel, index: number) => {
                    return (
                      <tr key={index}
                        onClick={() => this.selecionarContrato(contrato)}
                      >
                        <td>
                          {contrato.Disponivel &&
                            contrato.Selecionado && (
                              <i
                                className={
                                  "fas fa-circle text-success"
                                }
                              ></i>
                            )}

                          {contrato.Disponivel &&
                            !contrato.Selecionado && (
                              <i
                                className={
                                  "far fa-circle"
                                }
                              ></i>
                            )}

                          {!contrato.Disponivel && (
                            <i
                              className={
                                "far fa-times-circle text-danger"
                              }
                            ></i>
                          )}
                        </td>
                        <td>{contrato.Prazo}</td>
                        <td>
                          <CampoEstatico
                            valor={
                              contrato.TaxaJuros
                            }
                            tipo={
                              TipoCampoEstatico.percentual
                            }
                          />
                        </td>
                        <td>
                          <CampoEstatico
                            valor={
                              contrato.ValorPrestacao
                            }
                            tipo={
                              TipoCampoEstatico.dinheiro
                            }
                          />
                        </td>
                        <td>
                          <CampoEstatico
                            valor={
                              contrato.ValorTaxaAdministracao +
                              contrato.ValorTaxaInadimplencia +
                              contrato.ValorIOF
                            }
                            tipo={
                              TipoCampoEstatico.dinheiro
                            }
                          />
                        </td>
                        <td>
                          <CampoEstatico
                            valor={
                              contrato.ValorLiquido
                            }
                            tipo={
                              TipoCampoEstatico.dinheiro
                            }
                          />
                        </td>
                        <td>
                          {contrato.Disponivel && (
                            <span
                              className={
                                "text-success"
                              }
                            >
                              Disponível
                            </span>
                          )}

                          {!contrato.Disponivel && (
                            <span
                              className={
                                "text-danger"
                              }
                            >
                              {contrato.Motivo}
                            </span>
                          )}
                        </td>
                      </tr>
                    );
                  }
                )}
              </tbody>
            </table>
          )}

          <Botao
            titulo={"Voltar"}
            tipo={TipoBotao.light}
            onClick={() => this.props.history.goBack()}
            icone={"fas fa-chevron-left"}
          />

          <Botao
            titulo={"Resumo e Requerimento"}
            className={"ml-2"}
            onClick={this.continuar}
            icone={"fas fa-chevron-right"}
            desativado={!this.state.contratoSelecionado}
            iconeDireita
            submit
          />
        </Box>
      </MasterPage>
    );
  }
}
